import { formatDate } from '@/utils/formatDate';

export const getNoteStatus = (condition: boolean, createdAt: string, updatedAt: string) =>
  condition ? `Создано ${formatDate(createdAt)}` : `Изменено ${formatDate(updatedAt)}`;
